import { Alert, List, ListItem, Stack, Text } from '@chakra-ui/react'
import type { FieldErrors, FieldValues } from 'BrokerTsLib/src/rhf'
import { getObjectKeyValues } from 'BrokerTsLib/src/Utils/objectKeyUtils'
import { forwardRef } from 'react'

// Redecalare forwardRef
declare module 'react' {
  function forwardRef<T, P = {}>(
    render: (props: P, ref: React.Ref<T>) => React.ReactNode | null
  ): (props: P & React.RefAttributes<T>) => React.ReactNode | null
}


type ErrorSummaryProps<T extends FieldValues> = {
  errors: FieldErrors<T>
}


const ErrorSummary = <T extends object>({ errors }: ErrorSummaryProps<T>, ref: React.ForwardedRef<HTMLDivElement>) => {
  if (Object.keys(errors).length === 0) {
    return null
  }

  return (
    <Alert colorScheme="red" mb={8} ref={ref}>
      <Stack display={'flex'} ml={'auto'}>
        <List sx={{ display: 'flex', flexDir: 'column', alignItems: 'start' }} gap={1}>
          {
            getObjectKeyValues(errors)
              .filter(x => !!x.value?.message)
              .map((item) => (
                <ListItem key={item.fieldName}>
                  <Text variant={'danger'}>
                    {item.value?.message}
                  </Text>
                </ListItem>
              ))
          }
        </List>
      </Stack>
    </Alert>
  )
}

export default forwardRef(ErrorSummary)